import React, { useEffect, useRef, useState } from 'react';
import { SectionContainerLight } from '../common/sections/SectionContainerLight';

export const SectionLanding: React.FC = () => {
  const [slideIndex, setSlideIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const landingCarouselSlide = [
    {
      backroundImage: 'url("/img/bg-landing-page-1.jpg")',
      backroundImageOverlay: 'bg-gray-400 opacity-75',
      image: '/img/program/intro-to-it.png',
      imageclass: 'hidden md:block w-full h-auto max-w-[650px] mx-auto object-contain translate-y-[-20px]',
      title: 'Belajar Mudah, Kapan Saja, Dimana Saja!',
      text: 'Belajar dengan mentor profesional berpengalaman lebih dari 10 tahun, real project dari perusahaan, live online class, dan masih banyak lagi. Lulusan terbaik akan mendapatkan kesempatan untuk berkarir bersama kami lho!',
      textColor: 'text-white',
      callToActionText: 'Masih ragu dengan program AEDU? Cek di sini ya!',
      buttonText: 'Lihat Program',
      buttonHref: '#program-type',
    },
    {
      backroundImage: 'url("/img/home/bootcamp-image.png")',
      backroundImageOverlay: 'bg-gray-100 opacity-75',
      image: '/img/landing-page.png',
      imageclass: 'hidden md:block w-full h-auto max-w-[450px] mx-auto object-contain translate-y-[-20px]',
      title: 'Hidupmu Bisa Berubah Dalam Waktu 2 Bulan',
      subtitle: 'Program Intensif Siapkan Kamu Siap Kerja!',
      text: 'Program berbayar dengan kelas terstruktur, mentor profesional, dan dukungan karier. Dapatkan sertifikat, portofolio, dan peluang kerja nyata.',
      textColor: 'text-black',
      callToActionText: 'Investasi terbaik untuk masa depan kariermu!',
      buttonText: 'Daftar Program',
      buttonHref: 'http://link.accelist.com/daftarAEDU',
    },
    {
      backroundImage: 'url("/img/home/certification-image.jpg")',
      backroundImageOverlay: 'bg-black opacity-75',
      image: '/img/landing-page.png',
      imageclass: 'hidden md:block w-full h-auto max-w-[450px] mx-auto object-contain translate-y-[-20px]',
      title: 'Mau Keahlianmu Diakui Negara, Diakui Industri?',
      text: 'Lulus dari program ini, kamu dapat  Sertifikasi Kompetensi langsung dari BNSP, cocok buat melamar kerja di mana saja!',
      textColor: 'text-white',
      callToActionText: 'Daftar Pelatihan dan Sertifikasi BNSP sekarang!',
      buttonText: 'Daftar Program',
      buttonHref: 'http://link.accelist.com/daftarAEDUp',
    },
    {
      backroundImage: 'url("/img/home/bg-landing-2.png")',
      backroundImageOverlay: 'bg-gray-100 opacity-75',
      image: '/img/program/intro-to-it.png',
      imageclass: 'hidden md:block w-full h-auto max-w-[650px] mx-auto object-contain translate-y-[-20px]',
      title: 'Kesempatan Karier Setelah Lulus!',
      text: 'Lulusan terbaik berpeluang direkrut langsung oleh partner perusahaan kami. Siapkan portofolio dan bangun karier digitalmu sekarang!',
      textColor: 'text-black',
      callToActionText: 'Gabung dan raih peluang kerja nyata!',
      buttonText: 'Lihat Partner Kami',
      buttonHref: '#holding-partners',
    },
    {
      backroundImage: 'url("/img/home/extra-image.png")',
      backroundImageOverlay: 'bg-black opacity-75',
      image: '/img/landing-page.png',
      imageclass: 'hidden md:block w-full h-auto max-w-[450px] mx-auto object-contain translate-y-[-20px]',
      title: 'Ekskul Bukan Sekedar Hobi: Ini Awal Kariermu!',
      subtitle: 'Gabung Ekskul Favoritmu & Upgrade Skill Masa Depan 🔥',
      text: 'Eksplorasi minat & bakatmu lewat dunia robotik, coding, bisnis, dan konten kreatif! Temukan minatmu, pelajari skill nyata, dan kembangkan potensi sejak dini!',
      textColor: 'text-white',
      callToActionText: 'Mulai berkarya, berprestasi, dan membangun masa depanmu lewat kegiatan ekskul ini!',
      buttonText: 'Daftar Program',
      buttonHref: 'http://link.accelist.com/daftarAEDU',
    },
    {
      backroundImage: 'url("/img/home/digitalization-image.png")',
      backroundImageOverlay: 'bg-gray-400 opacity-75',
      image: '/img/landing-page.png',
      imageclass: 'hidden md:block w-full h-auto max-w-[450px] mx-auto object-contain translate-y-[-20px]',
      title: 'Digitalisasi Belajar? Kami Sudah Siap!',
      subtitle: 'All in One Learning System!💡 Proses Belajar Lebih Rapi, Interaktif, dan Terdokumentasi',
      text: 'Dengan platform LMS, semua aktivitas belajar lebih rapi, interaktif, dan terdokumentasi. Belajar jadi lebih efisien dan transparan: semua materi, diskusi, tugas, hingga progres belajar tercatat otomatis lewat LMS yang kami sediakan',
      textColor: 'text-black',
      buttonText: 'Install LMS Sekarang!',
      buttonHref: 'http://link.accelist.com/daftarAEDU',
    },
  ]

  const startSlideTimer = () => {
    intervalRef.current = setInterval(() => {
      setSlideIndex(prevIndex =>
        prevIndex + 1 >= landingCarouselSlide.length ? 0 : prevIndex + 1
      );
    }, 8000);
  };

  const resetSlideTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    startSlideTimer();
  };

  const handleSlideChange = (newIndex: number) => {
    if (newIndex < 0) {
      newIndex = landingCarouselSlide.length - 1;
    } else if (newIndex >= landingCarouselSlide.length) {
      newIndex = 0;
    }

    setSlideIndex(newIndex);
    resetSlideTimer(); // Reset timer on manual change
  };

  const formatTitle = (title: string) => {
    if (!title.includes("Hobi:")) return title;
    const [before, after] = title.split("Hobi:");
    return (
      <>
        {before}
        <span className="md:whitespace-nowrap">Hobi:{after}</span>
      </>
    );
  };

  // Start the timer on mount
  useEffect(() => {
    startSlideTimer();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  return (
    <SectionContainerLight id="landing" additionalClassName="!py-0 !my-0">
      <div className="relative bg-cover bg-center bg-no-repeat overflow-hidden min-h-[600px] md:min-h-[650px] w-full">
        {landingCarouselSlide.map((slide, index) => (
          <div key={index}
            className={`absolute top-0 left-0 h-full w-full transition-opacity duration-[2000ms] ease-in-out ${index === slideIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
            style={{
              backgroundImage: slide.backroundImage,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className={`h-[6px] w-full bg-accelist-green overflow-hidden ${index === slideIndex ? 'animate-slide-progress' : ''}`} />
            <div className={`absolute inset-0 ${slide.backroundImageOverlay}`} />
            <div className={`relative flex flex-wrap px-8 md:px-16 py-8 h-full ${slide.textColor}`}>
              <div className="w-full md:w-1/2 self-center px-4">
                <p className="text-3xl md:text-5xl font-body font-semibold tracking-wider leading-snug md:leading-relaxed mb-5 md:mb-10">
                  {formatTitle(slide.title)}
                </p>
                {slide.subtitle &&
                  <p className="text-2xl md:text-3xl font-body font-semibold md:text-justify tracking-wider leading-snug md:leading-relaxed -mb-3 md:-mb-4 -mt-3 md:-mt-6">
                    {slide.subtitle}
                  </p>
                }
                <p className="text-base md:text-xl font-body font-medium mb-3 md:mb-5 mt-5 md:mt-10 text-justify">
                  {slide.text}
                </p>
                <p className="text-base md:text-xl font-body font-medium mb-7 md:mb-12">
                  {slide.callToActionText}
                </p>
                <a href={slide.buttonHref} target="_blank" className="inline-block text-sm md:text-lg text-white bg-[#0D9488] font-semibold px-8 md:px-12 py-3 rounded-lg shadow-md hover:bg-[#1E293B] hover:text-[#FFFFFF] transition">
                  {slide.buttonText}
                </a>
              </div>
              <div className="w-full self-center md:w-1/2 mt-10 md:mt-0 min-w-[250px]">
                <img src={slide.image} alt={slide.title} className={slide.imageclass} />
              </div>
              <button onClick={() => handleSlideChange(index-1)}
               className='absolute left-0 top-1/2 p-0 md:w-10 md:h-10 h-9 w-9 ml-2 flex items-center justify-center rounded-full bg-accelist-green hover:bg-slate-200 hover:text-black'
               >
                <img src="/img/home/left-arrow.png" alt="Kiri" />
              </button>
              <button onClick={() => handleSlideChange(index+1)} className='absolute right-0 top-1/2 md:w-10 md:h-10 h-9 w-9 mr-2 flex items-center justify-center rounded-full bg-accelist-green hover:bg-slate-200 hover:text-black'>
                <img src="/img/home/right-arrow.png" alt="Kanan" />
              </button>
              <div className='absolute bottom-3 left-1/2 transform -translate-x-1/2 mb-2 flex flex-row items-center gap-2'>
                {landingCarouselSlide.map((item, index) => (
                  <button key={index} onClick={() => handleSlideChange(index)} className={`h-3 w-3 rounded-full hover:bg-slate-700 ${index === slideIndex ? 'bg-accelist-green' : 'bg-slate-400'}`}></button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </SectionContainerLight>
  );
};